import { useState, useEffect } from 'react';
import { Tag } from 'antd';
import styled from 'styled-components';
import NativeNumber from '../../component/Numeral';

const StatusCountStyle = styled.div`
	& > * {
		padding: 7px 15px;
		margin-right: 10px;
		margin-bottom: 10px;
	}
`;

interface StatusCount {
	all: number;
	migrated: number;
	pendingMigrate: number;
}
interface IStatusCount {
	statusTopupCount: StatusCount;
}
const InvestmentTopUpStatusCount = ({ statusTopupCount }: IStatusCount) => {
	const [counts, setCounts] = useState<any>({
		all: 0,
		migrated: 0,
		pendingMigrate: 0,
	});
	useEffect(() => {
		if (statusTopupCount) {
			setCounts({
				all: statusTopupCount?.all,
				migrated: statusTopupCount?.migrated,
				pendingMigrate: statusTopupCount?.pendingMigrate,
			});
		}
	}, [statusTopupCount]);

	return (
		<StatusCountStyle>
			<Tag color="yellow">
				<p>all</p>
				<p>
					<NativeNumber value={counts.all} />
				</p>
			</Tag>
			<Tag color="orange">
				<p>migrated</p>
				<p>
					<NativeNumber value={counts.migrated} />
				</p>
			</Tag>
			<Tag color="blue">
				<p>pendingMigrate</p>
				<p>
					<NativeNumber value={counts.pendingMigrate} />
				</p>
			</Tag>
		</StatusCountStyle>
	);
};

export default InvestmentTopUpStatusCount;
